import { socketClient } from '../socket/socketClient';

class SocketTransport {
  isReady() {
    return socketClient.connected;
  }

  async send(batch) {
    return await socketClient.emit('client-logs', batch);
  }
}

export const socketTransport = new SocketTransport();
